import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import { Field, reduxForm } from 'redux-form';

import TextField from 'components/fields/TextField';

import * as validate from 'utils/validate';

function onSubmit(values) {
  return values;
}

const ReportNameCreateForm = ({
  handleSubmit,
  className,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    <Grid container justify="center" spacing={24}>
      <Grid item xs={12}>
        <Field
          id="Name"
          name="Name"
          label="Report Template Name"
          component={TextField}
          validate={[validate.required]}
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

ReportNameCreateForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

ReportNameCreateForm.defaultProps = {
  className: '',
};

export default reduxForm({
  onSubmit,
})(ReportNameCreateForm);



// WEBPACK FOOTER //
// ./src/components/reports/ReportNameCreateDialog/ReportNameCreateForm.js